import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, Checkbox, Space, Typography } from "antd";
import { LocalStorageService } from "src/services/local-storage";
import { getNotificationModalDescription, getNotificationModalHeading, isNotificationModalHidden, notificationModalBlacklist } from "src/constants/general-notification";
import Button from "../button";
import styles from "./index.module.scss";

const { Title, Text } = Typography;
const localStorageService = new LocalStorageService();

function NotificationModal() {
  const { t } = useTranslation();

  const [dontShow, setDontShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [forceClose, setForceClose] = useState(false);

  useEffect(() => {
    // If any of the paths are included in the blacklist, force close the modal
    if (
      notificationModalBlacklist?.some(i =>
        window.location.pathname.includes(i)
      )
    ) {
      setForceClose(true);
      setIsOpen(false);
      return;
    }

    // If notification modal is not active, close the modal
    if (isNotificationModalHidden()) {
      setIsOpen(false);
      return;
    }

    // If 24 hour checkbox was checked
    const run = async () => {
      try {
        const res = await localStorageService.fetch("notificationModal");

        if (res) {
          const now = new Date();
          const parsed = JSON.parse(res);
          const lastDate = new Date(parsed);

          if (Number.isNaN(lastDate.getTime())) {
            localStorageService.remove("notificationModal");
            setIsOpen(true);
            return;
          }

          const diff = now.getTime() - lastDate.getTime();

          if (diff <= 24 * 60 * 60 * 1000) {
            setIsOpen(false);
            return;
          }

          localStorageService.remove("notificationModal");
        }

        setIsOpen(true);
      } catch (error) {
        setIsOpen(true);
      }
    };

    run();
  }, []);

  const onClose = () => {
    setIsOpen(false);

    if (dontShow) {
      try {
        const now = new Date();

        localStorageService.persist(
          "notificationModal",
          JSON.stringify(now),
        );
      } catch (error) {}
    }
  };

  return (
    (forceClose || !isOpen) ? (
      <></>
    ) : (
      <div className={styles.notification_modal}>
        <Card className={`${styles.card} ${styles.card_shadow}`}>
          <div className="d-flex-column align-items-center justify-content-between">
            <Title
              level={5}
              className="font-size-22 font-weight-500 text-center"
            >
              {getNotificationModalHeading(t)}
            </Title>
            <Text
              className="font-size-14 font-weight-400 text-center"
              style={{ whiteSpace: "pre-line" }}
            >
              {getNotificationModalDescription(t)}
            </Text>

            <Space className="pt-5 pb-5 font-weight-400 font-size-13">
              <Checkbox
                checked={dontShow}
                onChange={() => {
                  setDontShow(!dontShow);
                }}
              />
              {t("common.checkBoxContent24")}
            </Space>
            <Button
              title={t("button.close")}
              onBtnClick={onClose}
            />
          </div>
        </Card>
      </div>
    )
  );
};

export default NotificationModal;
